import {
  CallbackOnQueryUpdate,
  EventAll,
  EventNames,
  EventOnQueryUpdate,
  EventType,
} from './Events';

export type EventSubscriptions = {
  onQueryUpdate: EventOnQueryUpdate[];
  All: EventAll[];
};

class PubSub {
  private static events: EventSubscriptions = {
    onQueryUpdate: [],
    All: [],
  };

  public static subscribe = (event: EventType) => PubSub.events[event.eventName].push(event as any);

  public static unsubscribe = (event: EventType) => {
    if (PubSub.events[event.eventName]) {
      for (let i = 0; i < PubSub.events[event.eventName].length; i++) {
        if (PubSub.events[event.eventName][i] === event) {
          PubSub.events[event.eventName].splice(i, 1);
          break;
        }
      }
    }
  };

  public static publish = (eventName: EventNames, ...args: any) => {
    if (PubSub.events.All) {
      PubSub.events.All.forEach((event) => event.callback(eventName, args));
    }
    if (PubSub.events[eventName]) {
      PubSub.events[eventName].forEach((event: EventType) => {
        switch (eventName) {
          case 'onQueryUpdate':
            (event.callback as CallbackOnQueryUpdate)(args[0]);
            break;
          default:
            break;
        }
      });
    }
  };
}
export default PubSub;
